import React from "react";
import PasswordResetForm from "Components/home/PasswordResetForm";
import { Link } from "react-router-dom";
import HeroImage from "Components/home/widgets/HeroImage";
import * as actions from "Actions";
import { connect } from "react-redux";
import { parseQuery } from "HelperFunctions/QueryString";

const textColor = (value, dark = '#0E2C44') =>
  value === 'light' ? '#FFFFFF' : dark;

class PasswordReset extends React.Component {
  handleSubmit = data => {
    this.props.resetPassword({
      ...data,
      query: parseQuery(this.props.location.search)
    });
  };
  render() {
    const { storefrontEventsSetting } = this.props;
    const failed = parseQuery(this.props.location.search).success === "false";
    const displayTitle =
      storefrontEventsSetting.forgotPasswordPageTitle || 'Password Reset';
    const displayBody =
      storefrontEventsSetting.forgotPasswordPageBody ||
      'Track rentals, make payments, request changes. You made it!';
    const headlineStyle = {
      color: textColor(storefrontEventsSetting.forgotPasswordHeadlineTextColor),
    };
    const bodyStyle = {
      color: textColor(
        storefrontEventsSetting.forgotPasswordBodyTextColor,
        '#466B88'
      ),
    };
    return (
      <section className="password">
        <HeroImage
          picture={storefrontEventsSetting.customerPortalPicture}
          alt={displayTitle}
        />
        <div className="details">
          <h1 style={headlineStyle}>{displayTitle}</h1>
          <p style={bodyStyle}>{displayBody}</p>
        </div>
        {failed ? (
          <div className="passwordForm">
            <p>Oops! Your password reset has expired</p>
            <div className="actions">
              <Link className="btn full" to="/forgotPassword">
                Try sending another
              </Link>
            </div>
          </div>
        ) : (
          <div className="passwordForm">
            <PasswordResetForm onSubmit={this.handleSubmit} />
          </div>
        )}
      </section>
    );
  }
}

const mapStateToProps = state => {
  const { parsedStorefrontSettings } = state.locations;
  return {
    storefrontEventsSetting: parsedStorefrontSettings.storefrontEventsSetting,
  };
};

export default connect(mapStateToProps, actions)(PasswordReset);
